module.exports = __webpack_public_path__ + "media/images/dropdown-arrow-small-b3ad538273b907e7f0faef163fcc6534.svg";